export default {
  common: {
    add: 'Dodaj',
    cancel: 'Anuluj',
    description: 'Opis',
    delete: 'Usuń',
    title: 'Tytuł',
    save: 'Zapisz',
    faq: 'FAQ',
    contact: 'Kontakt',
    tos: 'Warunki korzystania z usługi',
    policy: 'Polityka prywatności'
  },
  board: {
    titlePlaceholder: 'Wprowadź tytuł karty',
    deleteDescription: 'Czy na pewno usunąć tę kartę?',
    editCard: 'Modyfikacja karty',
    deleteCard: 'Usunięcie karty',
    state: {
      TODO: 'DO ZROBIENIA',
      INPROGRESS: 'W TOKU',
      TESTING: 'TESTOWANIE',
      DONE: 'WYKONANE'
    }
  },
  chat: {
    online: 'Uzytkownicy Online ({count})',
    addChannel: 'Dodaj Kanał',
    channel: 'Kanał | Kanały',
    message: 'Wiadomość'
  },
  email: {
    compose: 'Nowy Email',
    send: 'Wyślij',
    subject: 'Temat',
    labels: 'Etykiety',
    emptyList: 'Pusta lista wiadmości',
    inbox: 'Odebrane',
    sent: 'Wysłane',
    drafts: 'Szkice',
    starred: 'Oznaczone gwiazdką',
    trash: 'Kosz',
    work: 'Praca',
    invoice: 'Faktura'
  },
  todo: {
    addTask: 'Dodaj Zadanie',
    tasks: 'Zadania',
    completed: 'Ukończone',
    labels: 'Etykiety'
  },
  dashboard: {
    activity: 'Aktywność',
    weeklySales: 'Sprzedaż tygodniowa',
    sales: 'Sprzedaż',
    recentOrders: 'Najnowsze zamówienia',
    sources: 'Traffic Sources',
    lastweek: 'w porównaniu do ostatniego tygodnia',
    orders: 'Zamówienia',
    customers: 'Klienci',
    tickets: 'Zgłoszenia',
    viewReport: 'Podgląd raportu'
  },
  usermenu: {
    profile: 'Profil',
    signin: 'Zaloguj',
    dashboard: 'Panel',
    signout: 'Wyloguj'
  },
  error: {
    notfound: 'Strona nie została odnaleziona',
    other: 'Wystąpił błąd'
  },
  check: {
    title: 'Ustaw Nowe hasło',
    backtosign: 'Powrót do logowania',
    newpassword: 'Nowe hasło',
    button: 'Ustaw nowe hasło i zaloguj',
    error: 'Link jest nieprawidłowy',
    verifylink: 'Weryfikacja linku...',
    verifyemail: 'Weryfikacja adresu email...',
    emailverified: 'Email Prawidłowy! Przekierowanie...'
  },
  forgot: {
    title: 'Nie pamiętasz hasła?',
    subtitle: 'Wprowadź swój adres email, żeby otrzymać link do resetowania hasła.',
    email: 'Email',
    button: 'Reset hasła',
    backtosign: 'Powrót do logowania'
  },
  login: {
    title: 'Witamy',
    subtitle: 'Zaloguj się na swoje konto',
    email: 'Email',
    password: 'Hasło',
    button: 'Zaloguj',
    orsign: 'Lub zaloguj się przez',
    forgot: 'Nie pamiętasz hasła?',
    noaccount: 'Nie masz konta?',
    create: 'Utwórz je tutaj',
    error: 'Kombinacja adresu email / hasła jest nieprawidłowa'
  },
  register: {
    title: 'Witamy',
    subtitle: 'Utwórz swoje konto',
    name: 'Imię i nazwisko',
    email: 'Email',
    password: 'Hasło',
    button: 'Utwórz konto',
    orsign: 'Lub zaloguj się przez',
    agree: 'Logując się akceptujesz',
    account: 'Masz już konto?',
    signin: 'Zaloguj'
  },
  utility: {
    maintenance: 'Przerwa techniczna'
  },
  faq: {
    call: 'Masz pytania? Sprawdź '
  },
  ecommerce: {
    products: 'Produkty',
    filters: 'Filtry',
    collections: 'Kolekcje',
    priceRange: 'Zakres cen',
    customerReviews: 'Opinie klientów',
    up: 'w górę',
    brand: 'Marka',
    search: 'Szukaj produkru',
    results: 'Wyniki ( {0} of {1} )',
    orders: 'Zamówienia',
    shipping: 'Dostawa',
    freeShipping: 'Darmowa dostawa',
    inStock: 'Dostępne',
    quantity: 'Ilość',
    addToCart: 'Dodaj do koszyka',
    buyNow: 'Kup teraz',
    price: 'Cena',
    about: 'Opis produktu',
    description: 'Opis',
    reviews: 'Oceny',
    details: 'Szczegóły produktu',
    cart: 'Koszyk',
    summary: 'Podsumowanie zamówienia',
    total: 'Łącznie',
    discount: 'Rabat',
    subtotal: 'Suma częściowa',
    continue: 'Kuntynuuj zakupy',
    checkout: 'Zamawiam'
  },
  menu: {
    search: 'Szukaj (press "ctrl + /" to focus)',
    dashboard: 'Panel',
    logout: 'Wyloguj',
    profile: 'Profil',
    blank: 'Pusta strona',
    pages: 'Strony',
    others: 'Inne',
    email: 'Email',
    chat: 'Chat',
    todo: 'Todo',
    board: 'Zadania',
    users: 'Użytkownicy',
    usersList: 'Lista',
    usersEdit: 'Modyfikuj',
    ecommerce: 'E-handel',
    ecommerceList: 'Produkty',
    ecommerceProductDetails: 'Szczegóły produktu',
    ecommerceOrders: 'Zamówienia',
    ecommerceCart: 'Koszyk',
    auth: 'Autoryzacja',
    authLogin: 'Logowanie',
    authRegister: 'Rejestracja',
    authVerify: 'Weryfikacja adresu email',
    authForgot: 'Nie pamiętam hasła',
    authReset: 'Reset Hasła',
    errorPages: 'Strony błędów',
    errorNotFound: 'Nie odnaleziono / 404',
    errorUnexpected: 'Błąd serwera / 500',
    utilityPages: 'Narzędzia',
    utilityMaintenance: 'Przerwa techniczna',
    utilitySoon: 'Wkrótce',
    utilityHelp: 'FAQ / Pomoc',
    levels: 'Poziomy Menu',
    disabled: 'Menu Wyłączone',
    docs: 'Dokumentacja',
    feedback: 'Opinie',
    support: 'Wsparcie',
    landingPage: 'Landing Page',
    pricingPage: 'Pricing Page'
  },
  // Vuetify components translations
  $vuetify: {
    badge: 'Plakietka',
    close: 'Zamknij',
    dataIterator: {
      noResultsText: 'Nie znaleziono odpowiadających rekordów',
      loadingText: 'Ładowanie elementów...'
    },
    dataTable: {
      itemsPerPageText: 'Wierszy na stronę:',
      ariaLabel: {
        sortDescending: 'Malejąco.',
        sortAscending: 'Rosnąco.',
        sortNone: 'Brak sortowania.',
        activateNone: 'Aktywuj aby usunąć sortowanie.',
        activateDescending: 'Aktywuj aby posortować malejąco.',
        activateAscending: 'Aktywuj aby posortować rosnąco.'
      },
      sortBy: 'Sortowanie wg'
    },
    dataFooter: {
      itemsPerPageText: 'Elementy na stronie:',
      itemsPerPageAll: 'Wszystkie',
      nextPage: 'Następna strona',
      prevPage: 'Poprzednia strona',
      firstPage: 'Pierwsza strona',
      lastPage: 'Ostatnia strona',
      pageText: '{0}-{1} z {2}'
    },
    datePicker: {
      itemsSelected: '{0} zaznaczonych',
      nextMonthAriaLabel: 'Kolejny miesiąc',
      nextYearAriaLabel: 'Kolejny rok',
      prevMonthAriaLabel: 'Poprzedni miesiąc',
      prevYearAriaLabel: 'Poprzedni rok'
    },
    noDataText: 'Brak danych',
    carousel: {
      prev: 'Poprzedni slajd',
      next: 'Następny slajd',
      ariaLabel: {
        delimiter: 'Slajd {0} z {1}'
      }
    },
    calendar: {
      moreEvents: '{0} więcej'
    },
    fileInput: {
      counter: '{0} plików',
      counterSize: '{0} plików ({1} ogółem)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Stronicowanie',
        next: 'Następna strona',
        previous: 'Poprzednia strona',
        page: 'Idź do strony {0}',
        currentPage: 'Aktualna strona, Strona {0}'
      }
    }
  }
}
